import { ActionTypes } from "../constants/actionTypes";

export const loaderAction = (loaderStatus) => async (dispatch) => {
  dispatch({
    type: ActionTypes.LOADER_STATUS,
    payload: loaderStatus,
  });
};
